import React from 'react';
import { ChevronIcon } from './ChevronIcon';

export interface CardExpandToggleProps {
  isExpanded: boolean;
  onClick: (e: React.MouseEvent) => void;
  /** Localized label text; content differs per card kind (e.g. "Expandir ticket" / "Expandir PR"). */
  ariaLabel: string;
}

/**
 * Chevron expand/collapse button shared by the Jira, Slack, GitHub, and
 * Agents card headers. The four call sites were byte-identical except for
 * the `aria-label` copy, which stays a prop here.
 */
export const CardExpandToggle: React.FC<CardExpandToggleProps> = ({
  isExpanded,
  onClick,
  ariaLabel,
}) => (
  <button
    type="button"
    onClick={onClick}
    aria-expanded={isExpanded}
    title={ariaLabel}
    aria-label={ariaLabel}
    style={{
      width: 28,
      height: 28,
      flex: '0 0 28px',
      borderRadius: 9,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'var(--z-muted-2)',
      background: 'var(--z-fill-2)',
      border: 'none',
      cursor: 'pointer',
    }}
  >
    <ChevronIcon size={15} direction={isExpanded ? 'down' : 'right'} />
  </button>
);
